import React from "react";
import { string, number } from "prop-types";

/* LinkedIn icon atom for team member cards */
const TeamLinkedInIcon = ({ color = "#242424", size = 16 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path 
      d="M3.58065 1.8C3.58065 2.79411 2.78065 3.6 1.79032 3.6C0.8 3.6 0 2.79411 0 1.8C0 0.805887 0.8 0 1.79032 0C2.78065 0 3.58065 0.805887 3.58065 1.8ZM3.6 5H0V16H3.6V5ZM8.68387 5H5.10968V16H8.68387V10.25C8.68387 7.06 12.8032 6.79 12.8032 10.25V16H16V9.01C16 3.5 10.1161 3.70375 8.68387 6.39625V5Z" 
      fill={color}
    />
  </svg>
);

TeamLinkedInIcon.propTypes = {
  color: string,
  size: number
};

export default TeamLinkedInIcon;

